// extracted by mini-css-extract-plugin
export var active = "_d9-7";
export var container = "_d9-0";
export var evenWidth = "_d9-4";
export var large = "_d9-5";
export var outlet = "_d9-8";
export var slide = "_d9-2";
export var small = "_d9-6";
export var tab = "_d9-3";
export var tabs = "_d9-1";